import {gql} from "@irati/utils/gql"

import paymentMethods from "./paymentMethods"

const fragment = gql`
  fragment paymentDetails on PaymentDetails {
    url
    paymentMethod
    channel
    merchantAccount
    pubKey
    clientKey
    shopperEmail
    shopperLocale
    paymentMethods {
      ...paymentMethods
    }
  }
  ${paymentMethods}
`

export const toString = fragment.loc.source.body

export default fragment
